import { useMemo } from 'react';
import { ColumnGroup } from 'react-table';

import { Actions } from 'components/Actions';

export const useColumns = (refetch: () => void) =>
  useMemo(
    (): ColumnGroup[] => [
      {
        Header: 'Notifications/Categories',
        columns: [
          {
            Header: 'Season Line',
            accessor: 'seasonLine',
          },
          {
            Header: 'Name (IT)',
            accessor: 'nameIt',
          },
          {
            Header: 'Name (EN)',
            accessor: 'nameEn',
          },
          {
            accessor: 'action',
            disableSortBy: true,
            Cell: ({ row }) => (
              <Actions
                isManagePath
                hasDelete
                toTheRight
                id={row.original.id}
                rowData={row.original}
                refetch={refetch}
                tableName="notificationsCategories"
              />
            ),
          },
        ],
      },
    ],
    [refetch]
  );
